import React from "react";
import { Box, Typography, Link } from "@mui/material";
import { Claim_ClaimsDbModel } from "@safelease/service-utilities";
import { mixpanelEventHandler } from "../../utilities/reactMixpanelHandler";
import { CLAIMS_MIXPANEL_EVENTS } from "./claimsMixpanelEvents";

/**
 * Footer component for Claim Details Drawer
 * Displays SafeLease contact information for all claims
 * Uses flexbox to stay at bottom of drawer
 */
export function ClaimDetailsFooter({ claim }: { claim?: Claim_ClaimsDbModel | null }) {
  const handlePhoneClick = () => {
    if (claim) {
      const locationId = claim.unit?.safeleaseLocationDetail?.locationId || null;
      mixpanelEventHandler(CLAIMS_MIXPANEL_EVENTS.drawer.phoneClicked, {
        claim_id: claim.id,
        claim_status: claim.status,
        locationId: locationId,
      });
    }
  };

  const handleEmailClick = () => {
    if (claim) {
      const locationId = claim.unit?.safeleaseLocationDetail?.locationId || null;
      mixpanelEventHandler(CLAIMS_MIXPANEL_EVENTS.drawer.safeleaseEmailClicked, {
        claim_id: claim.id,
        claim_status: claim.status,
        locationId: locationId,
      });
    }
  };

  return (
    <Box
      sx={{
        borderTop: "1px solid",
        borderColor: "divider",
        backgroundColor: "#ffffff",
        px: 3,
        py: 2,
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: "text.primary",
          }}
        >
          SafeLease
        </Typography>
        <Link
          href="mailto:claims@safelease.com"
          onClick={handleEmailClick}
          sx={{
            fontSize: "0.875rem",
            color: "primary.main",
            textDecoration: "none",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          claims@safelease.com
        </Link>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Typography
            variant="body2"
            sx={{
              fontSize: "0.875rem",
              color: "text.secondary",
            }}
          >
            Phone
          </Typography>
          <Link
            href="tel:+15127671408"
            onClick={handlePhoneClick}
            sx={{
              fontSize: "0.875rem",
              color: "primary.main",
              textDecoration: "none",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            512.767.1408
          </Link>
        </Box>
      </Box>
    </Box>
  );
}
